angular.module('document')
    .factory('Priority', function ($resource) {
        return $resource('/crm/api/document-priority', {}, {
            list: {method: 'GET', isArray: true}
        });
    })
